import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Badge from '../../common/base/Badge';
import Link from '../../common/base/Link';
import Text from '../../common/base/Text';
import { Div } from '../../common/helpers/StyledUtils';
const MAX_TOPICS_LIST = 3;
const MAX_TOPICS_PREVIEW = 6;

/**
 * Renders topics in list/table context: first N topics as badges, then static "+ x more".
 * Used in tenant list and destination list tables.
 */
export const TopicsList = t0 => {
  const $ = _c(11);
  const {
    topics
  } = t0;
  if (topics.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Text muted={true} size="s">None</Text>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (topics.length === 1 && topics[0] === "*") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Text size="s">All topics</Text>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 2,
      align: "center"
    };
    t2 = {
      overflow: "hidden"
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== topics) {
    t3 = topics.slice(0, MAX_TOPICS_LIST).map(_temp);
    $[4] = topics;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== topics.length) {
    t4 = topics.length > MAX_TOPICS_LIST && <Text size="xs" muted={true} text_wrap={false}>+{topics.length - MAX_TOPICS_LIST} more</Text>;
    $[6] = topics.length;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Div flex={t1} style={t2}>{t3}{t4}</Div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};

/**
 * Renders topics in overview/detail context: first N topics as badges, then clickable "+ x more"
 * that expands to show all topics.
 * Used in tenant overview (Subscribed Topics) and destination overview (Topics).
 */
export const TopicsOverview = t0 => {
  const $ = _c(14);
  const {
    topics
  } = t0;
  const [show_all, setShowAll] = useState(false);
  if (topics.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Text muted={true} size="s">None</Text>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (topics.length === 1 && topics[0] === "*") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Text>All topics</Text>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== show_all || $[3] !== topics) {
    t1 = show_all ? topics : topics.slice(0, MAX_TOPICS_PREVIEW);
    $[2] = show_all;
    $[3] = topics;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const visible_topics = t1;
  const remaining_count = topics.length - MAX_TOPICS_PREVIEW;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: 2,
      wrap: true
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== visible_topics) {
    t3 = visible_topics.map(_temp2);
    $[6] = visible_topics;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== remaining_count || $[9] !== show_all) {
    t4 = !show_all && remaining_count > 0 && <Link neutral={true} onClick={() => setShowAll(true)} m={{
      l: 1
    }}>+{remaining_count} more</Link>;
    $[8] = remaining_count;
    $[9] = show_all;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <Div flex={t2}>{t3}{t4}</Div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(topic) {
  return <Badge key={topic} neutral={true} subtle={true}>{topic}</Badge>;
}
function _temp2(topic) {
  return <Badge key={topic} neutral={true} subtle={true}>{topic}</Badge>;
}